<app-page-layout
  [title]="title"
  [subtitle]="subtitle"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Introduction Section -->
  <div class="intro-section">
    <h2>Assurance Crédit Professionnel</h2>
    <p>
      Si vous êtes à la recherche d'un <a href="javascript:void(0)" class="highlight-link">Crédit Professionnel</a>, nous travaillons avec un partenaire 
      de qualité, capable de vous trouver le crédit aux conditions négociées.
    </p>
  </div>

  <!-- Info Box -->
  <div class="info-box">
    <p>
      Merci svp de remplir le maximum d'informations dans le formulaire ci-dessous afin que le <a href="javascript:void(0)" class="highlight-link">courtier en crédit</a> puisse estimer la efficacité 
      de votre projet et préparer son appel. Un échange approfondi est nécessaire afin de déterminer le besoin exact et voir quelle solution il 
      vous faudra exactement.
    </p>
  </div>

  <!-- Contact Form Section -->
  <div class="form-section">
    <div class="form-container">
      <h3>Précisez votre besoin exact pour votre crédit professionnel</h3>
      <hr class="form-divider">

      <form (ngSubmit)="onSubmit()" #creditForm="ngForm">
        <div class="form-row">
          <div class="form-group">
            <label for="prenom">Nom complet <span class="required">*</span></label>
            <input 
              type="text" 
              id="prenom" 
              name="prenom"
              [(ngModel)]="formData.prenom"
              placeholder=""
              required>
            <span class="field-hint">Prénom</span>
          </div>
          <div class="form-group">
            <label for="nom" class="invisible">Nom</label>
            <input 
              type="text" 
              id="nom" 
              name="nom"
              [(ngModel)]="formData.nom"
              placeholder=""
              required>
            <span class="field-hint">Nom</span>
          </div>
        </div>

        <div class="form-group">
          <label for="email">Adresse e-mail <span class="required">*</span></label>
          <input 
            type="email" 
            id="email" 
            name="email"
            [(ngModel)]="formData.email"
            placeholder="ex: example@example.com"
            required>
        </div>

        <div class="form-group">
          <label for="telephone">Téléphone <span class="required">*</span></label>
          <input 
            type="tel" 
            id="telephone" 
            name="telephone"
            [(ngModel)]="formData.telephone"
            placeholder="00 00 00 00 00"
            required>
          <span class="field-hint">Veuillez entrer un numéro de téléphone valide.</span>
        </div>

        <div class="form-group">
          <label for="message">Message <span class="required">*</span></label>
          <textarea 
            id="message" 
            name="message"
            [(ngModel)]="formData.message"
            placeholder="Écrivez ici..."
            rows="6"
            required></textarea>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit">Envoyer</button>
        </div>

        <div class="form-clear">
          <a href="javascript:void(0)" (click)="clearForm()">Effacer</a>
        </div>
      </form>
    </div>
  </div>

</app-page-layout>
